// Seed data and helpers
export const FIRST = ['Aarav','Vivaan','Aditya','Vihaan','Arjun','Sai','Reyansh','Krishna','Ishaan','Shaurya','Atharv','Advik','Pranav','Rudra','Kabir','Ananya','Diya','Saanvi','Aanya','Pari','Aadhya','Kiara','Myra','Anika','Navya','Riya','Ira','Aaradhya','Avni','Sara','Tanvi','Mira','Zara','Inaya']
export const LAST = ['Sharma','Verma','Patel','Reddy','Iyer','Mehta','Singh','Kapoor','Gupta','Joshi','Nair','Khan','Bose','Pillai','Chopra','Bhatia','Rao','Shah','Desai','Saxena']
export const DEPTS = ['Engineering','Product','Design','Marketing','Sales','Operations','Customer Success','Finance','HR','Data']
export const CITIES = ['Bengaluru','Mumbai','Delhi','Hyderabad','Pune','Chennai','Gurugram','Noida','Kolkata','Ahmedabad']
export const TASKS_POOL = [
  'Reviewed PR #482 for the auth refactor and merged after fixing edge cases',
  'Completed onboarding flow wireframes for the new mobile app',
  'Closed 4 customer support tickets related to billing',
  'Shipped the new dashboard analytics widget to staging',
  'Led 1:1s with 3 junior team members',
  'Drafted Q3 OKRs document with marketing team',
  'Investigated database slow query — identified missing index',
  'Conducted user research interviews with 5 enterprise customers',
  'Pushed v2.4.1 hotfix for the WhatsApp webhook timeout bug',
  'Completed code review for inventory module refactor',
  'Wrote technical spec for new export-to-PDF feature',
  'Synced with design team on the upcoming Q3 release',
  'Resolved production incident affecting 2% of users',
  'Updated API documentation with v3 endpoint changes',
  'Reviewed marketing copy for landing page revamp',
  'Migrated legacy reports module to new graph backend',
  'Closed deal with Stellar Co — ₹4.2L ARR',
  'Built Figma prototype for mobile WhatsApp flow',
  'Cleared inbox and triaged 23 incoming bug reports',
  'Pair-programmed with new joinee on payment integration'
]
export const BLOCKERS_POOL = [
  'Waiting on design assets for the export PDF feature',
  'Need access to staging database for testing',
  'Blocked on legal approval for vendor agreement',
  'Production environment unstable — DevOps investigating'
]

const rand = (a) => a[Math.floor(Math.random() * a.length)]
export const initials = (n) => n.split(' ').map(s => s[0]).slice(0, 2).join('').toUpperCase()
export const avatarColor = (seed) => {
  const colors = ['#8B5CF6','#EC4899','#F59E0B','#10B981','#3B82F6','#EF4444','#14B8A6','#F97316']
  return colors[seed % colors.length]
}
// Time-of-day greeting from the local system clock: morning 5–11:59,
// afternoon 12–16:59, evening otherwise.
export const greeting = (d = new Date()) => {
  const h = d.getHours()
  if (h >= 5 && h < 12) return 'Good morning'
  if (h >= 12 && h < 17) return 'Good afternoon'
  return 'Good evening'
}

export const fmt = {
  num: n => n.toLocaleString('en-IN'),
  inr: n => '₹' + n.toLocaleString('en-IN'),
  date: d => new Date(d).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }),
  dateTime: d => new Date(d).toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }),
  time: d => new Date(d).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }),
  rel: d => {
    const s = Math.floor((Date.now() - new Date(d)) / 1000)
    if (s < 60) return 'just now'
    if (s < 3600) return Math.floor(s / 60) + 'm ago'
    if (s < 86400) return Math.floor(s / 3600) + 'h ago'
    return Math.floor(s / 86400) + 'd ago'
  }
}

export function seedState() {
  const employees = []
  for (let i = 0; i < 28; i++) {
    const fn = rand(FIRST), ln = rand(LAST)
    const name = fn + ' ' + ln
    const dept = rand(DEPTS)
    employees.push({
      id: 'emp_' + i,
      name,
      email: fn.toLowerCase() + '.' + ln.toLowerCase() + '@reportflow.io',
      phone: '+91 9' + (800000000 + Math.floor(Math.random() * 99999999)),
      department: dept,
      role: i < 3 ? 'Manager' : (i < 6 ? 'Lead' : 'Member'),
      city: rand(CITIES),
      status: Math.random() > 0.1 ? 'active' : 'inactive',
      joinDate: new Date(2023 + Math.floor(Math.random() * 3), Math.floor(Math.random() * 12), 1 + Math.floor(Math.random() * 27)).toISOString(),
      reportsCount: Math.floor(Math.random() * 120) + 30,
      compliance: Math.floor(Math.random() * 30) + 70,
      hoursAvg: Math.floor(Math.random() * 4) + 6,
      whatsapp: Math.random() > 0.15
    })
  }
  const reports = []
  const now = new Date()
  for (let d = 0; d < 14; d++) {
    const day = new Date(now); day.setDate(day.getDate() - d)
    employees.forEach(e => {
      if (e.status === 'inactive') return
      if (Math.random() > 0.85 && d === 0) return
      const taskCount = 2 + Math.floor(Math.random() * 4)
      const tasks = []
      const used = new Set()
      while (tasks.length < taskCount) {
        const t = rand(TASKS_POOL)
        if (used.has(t)) continue
        used.add(t)
        tasks.push({ text: t, status: Math.random() > 0.2 ? 'done' : (Math.random() > 0.5 ? 'in-progress' : 'blocker') })
      }
      const blockers = Math.random() > 0.7 ? [rand(BLOCKERS_POOL)] : []
      const hours = 5 + Math.random() * 5
      reports.push({
        id: 'rep_' + d + '_' + e.id,
        employeeId: e.id,
        date: day.toISOString().split('T')[0],
        submittedAt: new Date(day.setHours(17 + Math.random() * 4, Math.floor(Math.random() * 60))).toISOString(),
        tasks,
        blockers,
        hoursWorked: Math.round(hours * 10) / 10,
        sentiment: Math.random() > 0.85 ? 'low' : (Math.random() > 0.4 ? 'neutral' : 'high'),
        status: 'submitted',
        aiSummary: `${e.name.split(' ')[0]} completed ${tasks.filter(t => t.status === 'done').length} tasks across ${e.department}, logging ${Math.round(hours * 10) / 10}h. ${blockers.length ? 'Flagged: ' + blockers[0] : 'No blockers reported.'} Productivity ${tasks.filter(t => t.status === 'done').length > 2 ? 'strong' : 'steady'} for the day.`,
        source: e.whatsapp ? 'whatsapp' : 'web'
      })
    })
  }
  const departments = DEPTS.map((d, i) => {
    const heads = employees.filter(e => e.department === d)
    return {
      id: 'dept_' + i, name: d,
      manager: heads[0]?.name || '—',
      employeeCount: heads.length,
      avgCompliance: Math.round(heads.reduce((s, e) => s + e.compliance, 0) / Math.max(1, heads.length)),
      created: new Date(2022, Math.floor(Math.random() * 12), 1).toISOString()
    }
  })
  const notifs = [
    { id: 1, type: 'submit', title: 'New report submitted', msg: 'Aarav Sharma submitted today\'s daily report via WhatsApp', time: new Date(Date.now() - 5 * 60000).toISOString(), unread: true, icon: 'file-check' },
    { id: 2, type: 'alert', title: '12 employees pending', msg: '12 team members haven\'t submitted today\'s report', time: new Date(Date.now() - 30 * 60000).toISOString(), unread: true, icon: 'alert-triangle' },
    { id: 3, type: 'success', title: 'Weekly report ready', msg: 'Engineering team weekly summary is ready to view', time: new Date(Date.now() - 2 * 3600000).toISOString(), unread: true, icon: 'sparkles' },
    { id: 4, type: 'info', title: 'WhatsApp bot updated', msg: 'New AI model deployed — reports are now 30% more accurate', time: new Date(Date.now() - 5 * 3600000).toISOString(), unread: false, icon: 'message-circle' },
    { id: 5, type: 'info', title: 'Subscription renewal', msg: 'Your Business plan renews in 12 days', time: new Date(Date.now() - 86400000).toISOString(), unread: false, icon: 'credit-card' }
  ]
  return {
    user: { name: 'Aarav Sharma', email: 'admin@reportflow.io', role: 'Admin', initials: 'AS', org: 'Acme Pvt Ltd', plan: 'Business' },
    employees, reports, departments, notifs,
    settings: {
      theme: 'dark', reminderTime: '18:00', weekendOff: true,
      whatsapp: { enabled: true, phone: '+91 90000 12345', apiKey: 'wh_live_8x7************2k', webhookUrl: 'https://api.reportflow.io/wh/inbound' },
      notifications: { email: true, inApp: true, push: false, reportSubmit: true, pendingAlert: true, weeklyDigest: true }
    }
  }
}
